'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import { cn } from '@workspace/ui/lib';
import { useState } from 'react';

interface PrivateFeedbackFormProps {
  rating: number;
  onSubmit: (feedback: string) => void;
  isSubmitting?: boolean;
  loadingText: string;
}

export function PrivateFeedbackForm({
  rating,
  onSubmit,
  isSubmitting = false,
  loadingText,
}: PrivateFeedbackFormProps) {
  const [feedback, setFeedback] = useState('');

  const handleSubmit = () => {
    onSubmit(feedback);
  };

  const textareaId = 'nps-feedback-textarea';

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h3 className="text-xl font-bold text-neutral-200 dark:text-neutral-100">
          Thank you for your feedback
        </h3>
        <p className="text-grey-600 dark:text-grey-400 text-sm">
          You rated us {rating}/10. We&apos;d love to understand how we can improve. Your feedback
          is private and will only be seen by our team.
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <label htmlFor={textareaId} className="sr-only">
          Feedback
        </label>
        <textarea
          id={textareaId}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          disabled={isSubmitting}
          placeholder="Tell us what we could do better..."
          rows={4}
          aria-label="Feedback"
          className={cn(
            'w-full resize-none rounded-2xl border px-4 py-3 text-base leading-5 outline-none transition-all',
            'border-grey-300 hover:border-primary dark:border-grey-700 focus-visible:border-primary',
            'placeholder:text-grey-700 dark:placeholder:text-grey-500',
            'text-primary dark:text-neutral-100',
            'dark:bg-transparent',
            'disabled:cursor-not-allowed disabled:opacity-50'
          )}
        />
      </div>

      <Button
        type="button"
        variant="pink"
        size="lg"
        isLoading={isSubmitting}
        loadingText={loadingText}
        onClick={handleSubmit}
        className="w-full"
      >
        <p>Submit Feedback</p>
      </Button>
    </div>
  );
}
